import {Component, Inject} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
   selector: 'app-delete-attach-file',
   templateUrl: './delete-attach-file.component.html',
   styleUrls: ['./delete-attach-file.component.css']
})
export class DeleteAttachFileComponent {

   progress: boolean;
   checkButton = false;

   constructor(private _formBuilder: FormBuilder, private dialogRef: MatDialogRef<DeleteAttachFileComponent>,
               private translate: TranslateService,
               @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   onClickOk() {
      this.checkButton = true;
      this.data.service.deleteAttachFile(this.data.docId, this.data.taskId)
         .subscribe(() => {
               this.checkButton = false;
               this.dialogRef.close({response: true});

            },
            (error1) => {
               this.dialogRef.close({response: false});
               this.data.toast.error(error1);
            });
   }

}
